<script>
  export let rumbleUrl;
  export let onClose;

  // Add any necessary script for Rumble here
</script>

<div class="modal">
  <button on:click={onClose}>Close</button>
  <iframe src={rumbleUrl} frameborder="0" allowfullscreen></iframe>
</div>

<style>
  .modal {
    /* Your modal styling */
  }
  iframe {
    width: 100%;
    height: 400px; /* Adjust as needed */
  }
</style>
